<mat-card appearance="outlined" style="flex: 1 1 30vw">
  <form [formGroup]="adminForm">
    @if (data.type === AdminT.BranchAdmin) {
    <mat-card-title i18n>Branch Admin Data</mat-card-title>
    } @if (data.type === AdminT.ChainAdmin) {
    <mat-card-title i18n>Chain Admin Data</mat-card-title>
    } @switch (true) { @case (data === undefined) {
    <p style="color: #b9284b" i18n="@@waitingForData">
      Waiting for the data...
    </p>
    } @default {
    <mat-card-content>
      <div class="flex-row start-center gap-20">
        <mat-form-field style="flex: 1 1 100%">
          <mat-label i18n="@@email">E-mail</mat-label>
          <input matInput formControlName="email" type="email" />
        </mat-form-field>
      </div>
      <div class="flex-row space-between-center gap-20">
        <mat-form-field style="flex: 1 0 45%">
          <mat-label i18n="@@fullName">Full name</mat-label>
          <input matInput formControlName="name" />
        </mat-form-field>
        <mat-form-field style="flex: 1 0 45%">
          <mat-label i18n="@@phone">Phone Number</mat-label>
          <input matInput formControlName="phone" />
        </mat-form-field>
      </div>
      @if (data.type === AdminT.BranchAdmin) {
      <div class="flex-row start-center gap-20">
        <mat-form-field style="flex: 1 0 45%">
          <mat-label i18n="@@selectBranch">Select Branch</mat-label>
          <mat-select formControlName="branch">
            <mat-option [value]="null">---</mat-option>
            @for (branch of branches ; track branch) {
            <mat-option [value]="branch.uuid">{{ branch.name }}</mat-option>
            }
          </mat-select>
          @if (adminForm.controls.branch.value !== null ) {
          <button
            matSuffix
            matIconButton
            aria-label="Clear"
            (click)="clearBranch()"
          >
            <mat-icon>close</mat-icon>
          </button>
          }
        </mat-form-field>
      </div>
      } @if (data.type === AdminT.ChainAdmin) {
      <div class="flex-row start-center gap-20">
        <mat-form-field style="flex: 1 0 45%">
          <mat-label i18n="@@selectChain">Select Chain</mat-label>
          <mat-select formControlName="chains" multiple>
            @for (chain of chains ; track chain) {
            <mat-option [value]="chain.uuid">{{ chain.name }}</mat-option>
            }
          </mat-select>
          @if (adminForm.controls.chains.value !== null ) {
          <button
            matSuffix
            matIconButton
            aria-label="Clear"
            (click)="clearChain()"
          >
            <mat-icon>close</mat-icon>
          </button>
          }
        </mat-form-field>
      </div>
      }
      <div class="flex-row start-center gap-20">
        <mat-form-field style="flex: 1 0 45%">
          <mat-label i18n="@@externalId">External Id</mat-label>
          <input matInput formControlName="externalId" />
        </mat-form-field>
      </div>
      @if (changePassword) {
      <div
        formGroupName="passGroup"
        class="flex-row space-between-center gap-20"
      >
        <mat-form-field style="flex: 1 0 45%">
          <mat-label i18n="@@password">Password</mat-label>
          <input matInput formControlName="password" type="password" i18n />
          @if (adminForm.get('passGroup').hasError('required', 'password')) {
          <mat-error i18n> Please enter your new password </mat-error>
          } @if (adminForm.get('passGroup').hasError('minlength', 'password')) {
          <mat-error i18n> Password must contain min 6 characters </mat-error>
          } @if (adminForm.get('passGroup').hasError('pattern', 'password')) {
          <mat-error i18n>
            Password must contain one upper character and one digit
          </mat-error>
          }
        </mat-form-field>
        <mat-form-field style="flex: 1 0 45%">
          <mat-label i18n="@@confirmPassword">Confirm Password</mat-label>
          <input
            matInput
            formControlName="confirmPass"
            type="password"
            [errorStateMatcher]="matcher"
            i18n
          />
          @if (adminForm.get('passGroup').hasError('notSame')) {
          <mat-error> Passwords do not match </mat-error>
          }
        </mat-form-field>
      </div>
      } @else {
      <button
        matButton="outlined"
        color="accent"
        (click)="onChangePassword()"
      >
        <mat-icon style="margin-right: 0.5em">vpn_key</mat-icon>
        <span   i18n="buttonChangePassword">Change Password</span>
      </button>
      }
    </mat-card-content>
    <mat-card-actions>
      <br />
      <div
        class="flex-row start-center gap-20"
        style="padding-left: 30px"
        mat-dialog-actions
      >
        <button matButton="outlined" i18n="@@buttonClose" (click)="onClose()">
          Close
        </button>
        <button
          matButton="elevated"
          color="accent"
          (click)="onSave()"
          [disabled]="adminForm.invalid || !adminForm.touched"
          i18n="@@buttonSave"
        >
          Save
        </button>
        <span style="flex: 1 1 auto"></span>
        @if (editMode) {
        <button
          matButton="outlined"
          color="primary"
          (click)="onLockUser()"
        >
          <mat-icon style="margin-right: 0.5em">lock</mat-icon><span i18n="buttonLockUser">Lock User</span>
        </button>
        }
      </div>
    </mat-card-actions>
    } }
  </form>
</mat-card>
